import { useState } from 'react';

import { LoadingIndicator } from '../../../common/LoadingIndicator/LoadingIndicator';
import { Position } from '../../../common/Map/CloselinkMap';
import { Section } from '../../../common/Section/Section';
import { OfferModel } from '../../model/OfferModel';

import { OfferPositionsMap } from './components/OfferPositionsMap';
import { PositionList } from './components/PositionList';
import { useOfferPositions } from './hooks/useOfferPositions';
import { PositionData } from './types/PositionData';

interface OfferPositionsProps {
    offer: OfferModel;
}

export const OfferPositions = ({ offer }: OfferPositionsProps) => {
    const [mapCamera, setMapCamera] = useState<{ center: Position; zoom: number } | undefined>(undefined);
    const offerPositionsQuery = useOfferPositions(offer);

    if (offerPositionsQuery.isPending) {
        return (
            <Section fullHeight>
                <LoadingIndicator />
            </Section>
        );
    }

    const offerPositions = offerPositionsQuery.data as PositionData[];

    const handlePositionClick = (position: PositionData) => {
        setMapCamera({
            center: position.position,
            zoom: offerPositions.length === 1 ? 10 : 5,
        });
    };

    const handleCameraChanged = (center: Position, zoom: number) => {
        setMapCamera({ center, zoom });
    };

    return (
        <Section paddingY={0}>
            <OfferPositionsMap
                positionData={offerPositions}
                center={mapCamera?.center}
                zoom={mapCamera?.zoom}
                onCameraChanged={handleCameraChanged}
            />
            <PositionList positionData={offerPositions} onActivePositionChange={handlePositionClick} />
        </Section>
    );
};
